import { Link } from "react-router-dom";

import { nFormatter } from "../../utils/parseNumber";
import { VerifiedButton } from "./VerifiedButton";
import { store } from "../../store";
import { hideAllMenus } from "store/application/application-action";
import { routes } from "routes";
import avarPreview from "components/icons/avatar-preview.png";
import { ICurrentUser } from "store/user/user-state";
import "./ProfileMenuHeader.scss";

export const ProfileMenuHeader = (props: {
  user: ICurrentUser;
}): JSX.Element => {
  const { user } = props;

  const onClick = () => {
    store.dispatch(hideAllMenus());
  };

  return (
    <div className="menuHeader">
      <div className="first">
        <div className="userpic">
          <Link to={routes.user(user.username)} onClick={onClick}>
            <img src={user.profileImageUrl || avarPreview} alt="user avatar" />
          </Link>
        </div>
        <div className="userInfo">
          <div className="userName">
            <div className="name">{user.name ? user.name : user.username}</div>
          </div>
          <div className="metrics">
            <Link to={routes.followers()} onClick={onClick}>{nFormatter(user.followers)} <span>Followers</span></Link>
            <div className="separator"></div>
            <div>{nFormatter(user.views)} <span>Views</span></div>
          </div>
        </div>
      </div>

      {!user.verified && <VerifiedButton />}
    </div>
  );
};
